import { render } from "./PageNumber5.vue?vue&type=template&id=59ebfa1c&scoped=true"
import script from "./PageNumber5.vue?vue&type=script&lang=js"
export * from "./PageNumber5.vue?vue&type=script&lang=js"

import "./PageNumber5.vue?vue&type=style&index=0&id=59ebfa1c&scoped=true&lang=css"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ebfa1c"]])

export default __exports__